import * as React from 'react';
import { SharedUiPropertyLegalDisclaimerWrapper } from 'components/infosite/shared-ui/offers/property-legal-disclaimer-wrapper';
export const LegalDisclaimer = () => React.createElement(SharedUiPropertyLegalDisclaimerWrapper, null);